import { render, staticRenderFns } from "./Wzk.vue?vue&type=template&id=7813963c&scoped=true&"
import script from "./Wzk.vue?vue&type=script&lang=js&"
export * from "./Wzk.vue?vue&type=script&lang=js&"
import style0 from "./Wzk.vue?vue&type=style&index=0&id=7813963c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7813963c",
  null
  
)

export default component.exports